export { unstable_detectScrollType as detectScrollType, unstable_getNormalizedScrollLeft as getNormalizedScrollLeft } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/utils/scrollLeft.js
// module id = 2494
// module chunks = 31